import React from "react";
import Button from "../../button/button";

function PrimaryButton(props) {
    return <Button styleType="primary" {...props} />;
}

export default PrimaryButton;

PrimaryButton.propTypes = { ...Button.propTypes };
delete PrimaryButton.propTypes.styleType;

PrimaryButton.defaultProps = { ...Button.defaultProps };
